module.exports = __webpack_public_path__ + "static/suggestion_obj02@2x-52921149810af76dbf19927f62405363.png";